import { ORDER_STATUS_AWAITING_PAYMENT, ORDER_STATUS_CANCELED, ORDER_STATUS_DONE, ORDER_STATUS_EXPEDITED, ORDER_STATUS_EXPIRED, ORDER_STATUS_MOUNTING, ORDER_STATUS_OPEN, ORDER_STATUS_PENDING, ORDER_STATUS_RELEASED_SHIPMENT, ORDER_STATUS_RELEASED_TAKEAWAY, ORDER_STATUS_RETURNED, ORDER_STATUS_SCHEDULED } from "./Checkout";
import { ORDER_TYPE_DELIVERY_ID, ORDER_TYPE_DINE_IN_ID, ORDER_TYPE_DIRECT_SALE_ID, ORDER_TYPE_SCHEDULING_ID, ORDER_TYPE_STORE_COUNTER_ID, ORDER_TYPE_TAKE_AWAY_ID } from "./Service";

export const ORDER_CART_NOT_FOUND = 'order_not_found';

export const ORDER_TYPE_IDS: { [key: string]: number | null } = {
    'delivery': ORDER_TYPE_DELIVERY_ID,
    'take_away': ORDER_TYPE_TAKE_AWAY_ID,
    'dine_in': ORDER_TYPE_DINE_IN_ID,
    'scheduling': ORDER_TYPE_SCHEDULING_ID,
    'store_counter': ORDER_TYPE_STORE_COUNTER_ID,
    'direct_sale': ORDER_TYPE_DIRECT_SALE_ID,
    'default': null,
}

export const getOrderColorByStatusId = (orderStatus: number): string => {
    let typeBadge = '';
    switch (orderStatus) {
        case ORDER_STATUS_CANCELED: typeBadge = 'error'; break;
        case ORDER_STATUS_PENDING: typeBadge = 'default'; break;
        case ORDER_STATUS_OPEN: typeBadge = 'info'; break;
        case ORDER_STATUS_MOUNTING: typeBadge = 'alert'; break;
        case ORDER_STATUS_RELEASED_SHIPMENT: typeBadge = 'alert'; break;
        case ORDER_STATUS_EXPEDITED: typeBadge = 'alert'; break;
        case ORDER_STATUS_RETURNED: typeBadge = 'error'; break;
        case ORDER_STATUS_DONE: typeBadge = 'success'; break;
        case ORDER_STATUS_RELEASED_TAKEAWAY: typeBadge = 'info'; break;
        case ORDER_STATUS_SCHEDULED: typeBadge = 'required'; break;
        case ORDER_STATUS_AWAITING_PAYMENT: typeBadge = 'alert'; break;
        case ORDER_STATUS_EXPIRED: typeBadge = 'required'; break;
        default: break;
    }
    return typeBadge;
}

export const getOrderColorByStatusIdToPlaced = (orderStatus: number): string => {
    let typeBadge = '';
    switch (orderStatus) {
        case ORDER_STATUS_CANCELED: typeBadge = 'error'; break;
        case ORDER_STATUS_PENDING: typeBadge = 'required'; break;
        case ORDER_STATUS_OPEN: typeBadge = 'required'; break;
        case ORDER_STATUS_MOUNTING: typeBadge = 'required'; break;
        case ORDER_STATUS_RELEASED_SHIPMENT: typeBadge = 'required'; break;
        case ORDER_STATUS_EXPEDITED: typeBadge = 'required'; break;
        case ORDER_STATUS_RETURNED: typeBadge = 'alert'; break;
        case ORDER_STATUS_DONE: typeBadge = 'success'; break;
        case ORDER_STATUS_RELEASED_TAKEAWAY: typeBadge = 'required'; break;
        case ORDER_STATUS_SCHEDULED: typeBadge = 'required'; break;
        case ORDER_STATUS_AWAITING_PAYMENT: typeBadge = 'required'; break;
        case ORDER_STATUS_EXPIRED: typeBadge = 'required'; break;
        default: break;
    }
    return typeBadge;
}
